/* Moved from sections/hlth-reviews-carousel.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(SID) {
      (function() {
        var root = document.getElementById('shopify-section-' + SID + '');
        if (!root) return;
        var track = root.querySelector('[data-rc-track]');
        if (!track) return;
        var cards = track.querySelectorAll('[data-rc-card]');
        if (!cards.length) return;
        var dots = root.querySelectorAll('[data-rc-dot]');
        var prevBtn = root.querySelector('[data-rc-prev]');
        var nextBtn = root.querySelector('[data-rc-next]');

        var origCount = parseInt(track.getAttribute('data-rc-original-count'), 10) || cards.length;
        // When there are multiple originals, cards are rendered 3× for looping:
        // [before clones][originals][after clones]. middleStart = index of first original.
        var hasClones = cards.length === origCount * 3;
        var middleStart = hasClones ? origCount : 0;
        var initialOrigIdx = Math.floor(origCount / 2);
        var initialIdx = middleStart + initialOrigIdx;
        // Logical index drives navigation intent and is kept consistent even when a
        // smooth scroll animation is mid-flight (reading scrollLeft would be stale).
        var logicalIdx = initialIdx;

        function step() {
          if (cards.length < 2) return track.clientWidth;
          var a = cards[0].getBoundingClientRect().left;
          var b = cards[1].getBoundingClientRect().left;
          var s = b - a;
          return s > 0 ? s : cards[0].offsetWidth + 14;
        }

        function currentIdx() {
          var s = step();
          if (!s) return initialIdx;
          return Math.round(track.scrollLeft / s);
        }

        function mapToOriginal(idx) {
          if (!hasClones) return idx;
          return ((idx - middleStart) % origCount + origCount) % origCount;
        }

        function setScroll(idx, animated) {
          var target = idx * step();
          try {
            track.scrollTo({ left: target, behavior: animated ? 'smooth' : 'instant' });
          } catch (e) {
            // Older browsers without scrollTo options support
            track.scrollLeft = target;
          }
        }

        function updateDots(origIdx) {
          if (!dots || !dots.length) return;
          Array.prototype.forEach.call(dots, function(dot, idx) {
            var active = idx === origIdx;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', active ? 'true' : 'false');
          });
        }

        function navigate(direction) {
          logicalIdx += direction;
          setScroll(logicalIdx, true);
          updateDots(mapToOriginal(logicalIdx));
        }

        function goToOriginal(origIdx) {
          // Dot clicks always jump to the main (middle) set for predictable behavior.
          logicalIdx = middleStart + origIdx;
          setScroll(logicalIdx, true);
          updateDots(origIdx);
        }

        // When scrolling settles, if we've drifted into a clone region, silently
        // jump to the equivalent position in the main set so the loop is seamless.
        function settleLoop() {
          if (!hasClones) return;
          var idx = currentIdx();
          // Accept the user's latest actual position as truth after settle.
          logicalIdx = idx;
          if (idx < middleStart) {
            logicalIdx = idx + origCount;
            setScroll(logicalIdx, false);
          } else if (idx >= middleStart + origCount) {
            logicalIdx = idx - origCount;
            setScroll(logicalIdx, false);
          }
        }

        if (dots) {
          Array.prototype.forEach.call(dots, function(dot) {
            dot.addEventListener('click', function() {
              var i = parseInt(dot.getAttribute('data-rc-dot'), 10);
              if (!isNaN(i)) goToOriginal(i);
            });
          });
        }

        if (prevBtn) prevBtn.addEventListener('click', function() { navigate(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function() { navigate(1); });

        track.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); navigate(-1); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); navigate(1); }
          else if (e.key === 'Home') { e.preventDefault(); goToOriginal(0); }
          else if (e.key === 'End') { e.preventDefault(); goToOriginal(origCount - 1); }
        });

        var scrollRaf;
        var settleTimer;
        track.addEventListener('scroll', function() {
          if (scrollRaf) cancelAnimationFrame(scrollRaf);
          scrollRaf = requestAnimationFrame(function() {
            var idx = currentIdx();
            logicalIdx = idx;
            updateDots(mapToOriginal(idx));
          });
          // Debounced scroll-end detection for silent loop-back.
          clearTimeout(settleTimer);
          settleTimer = setTimeout(settleLoop, 140);
        });

        var initialized = false;

        window.addEventListener('resize', function() {
          // Re-anchor to the current original index after a viewport change so the
          // loop stays aligned with the new step size.
          var origIdx = initialized ? mapToOriginal(logicalIdx) : initialOrigIdx;
          logicalIdx = middleStart + origIdx;
          setScroll(logicalIdx, false);
          updateDots(origIdx);
        });

        // Initial positioning: center on the middle review, no animation.
        // Retry each frame until card layout produces a valid step — this handles
        // fonts loading, images reflowing, or section becoming visible late.
        function init(attempt) {
          attempt = attempt || 0;
          var s = step();
          if (!s && attempt < 30) {
            requestAnimationFrame(function() { init(attempt + 1); });
            return;
          }
          logicalIdx = initialIdx;
          setScroll(initialIdx, false);
          updateDots(initialOrigIdx);
          initialized = true;
        }

        requestAnimationFrame(function() { init(); });
        // Re-run once after load so late font/image reflows don't strand us off-snap.
        if (document.readyState === 'complete') {
          requestAnimationFrame(function() { init(); });
        } else {
          window.addEventListener('load', function() {
            requestAnimationFrame(function() { init(); });
          }, { once: true });
        }
        // Re-anchor when the track's measurable size changes (e.g., deferred layout,
        // hidden→visible, or viewport going from 0 to real width in embedded previews).
        if (typeof ResizeObserver !== 'undefined') {
          var ro = new ResizeObserver(function() {
            if (!initialized && step() > 0) {
              init();
            } else if (initialized) {
              var origIdx = mapToOriginal(logicalIdx);
              logicalIdx = middleStart + origIdx;
              setScroll(logicalIdx, false);
              updateDots(origIdx);
            }
          });
          ro.observe(track);
        }
      })();
  }
  function scan(scope) {
    var list = [];
    if (scope.classList && scope.classList.contains('hlth-s--hlth-reviews-carousel')) list.push(scope);
    scope.querySelectorAll('.hlth-s--hlth-reviews-carousel').forEach(function (w) { list.push(w); });
    list.forEach(function (w) {
      if (w.__hlthJs_hlth_reviews_carousel) return;
      w.__hlthJs_hlth_reviews_carousel = true;
      run(w.id.replace(/^shopify-section-/, ''));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
